import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Spacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
`;

type SpacerListItemProps = { height: number };

class SpacerListItem extends PureComponent<SpacerListItemProps> {
  static getHeight = ({ height }: SpacerListItemProps) => height;

  render() {
    const { height } = this.props;
    return <Spacer height={height} />;
  }
}

export default SpacerListItem;
